import { Injectable } from '@angular/core';
import { AddEditExamAgencyHttpService } from './add-edit-exam-agency.http.service';
import { AuthService } from 'src/app/Services/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { UserAuthManager } from '../../../../../Services/user-sessions/user-auth-manager';
import {
  HttpErrorUtil,
  HttpUnauthorizedException,
} from 'src/app/utils/http-util/http-error.util';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AddEditExamAgencyService {
  constructor(
    private readonly addEditExamAgencyHttpService: AddEditExamAgencyHttpService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly toaster: ToastrService
  ) {}

  getExamAgencyById<T>(loginUserId: string, examAgencyId: string) {
    return this.addEditExamAgencyHttpService
      .getExamAgencyById<T>(loginUserId, examAgencyId)
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((data) => (data as unknown as Array<T>)[0])
      );
  }

  getDropdownListCode(code: string) {
    return this.addEditExamAgencyHttpService.getDropdownListByCode(code).pipe(
      catchError((err: HttpErrorResponse) => this.handlerError(err)),
      map((data) => data)
    );
  }

  updateExamAgency<T, E>(examAgency: T) {
    return this.addEditExamAgencyHttpService
      .updateExamAgency<T, E>(examAgency)
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((data) => data)
      );
  }
  createExamAgency<T, E>(examAgency: T) {

    return this.addEditExamAgencyHttpService
      .createExamAgency<T, E>(examAgency)
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((data) => data)
      );
  }

  getState<T>(country: string) {
    return this.addEditExamAgencyHttpService.getState<T>(country).pipe(
      catchError((err: HttpErrorResponse) => this.handlerError(err)),
      map((data) => data)
    );
  }

  private handlerError(err: HttpErrorResponse) {
    const error = HttpErrorUtil.sanitizeError(err);

    if (error instanceof HttpUnauthorizedException) {
      UserAuthManager.userSessionLogout.next();
      this.authService.logout();
      this.router.navigate(['/login']);
      this.toaster.warning(error.message, 'Logout Successfully');
    } else {
      this.toaster.error(error.message, 'Error');
    }

    return throwError(error);
  }
}
